import React from 'react';
import './PartnerLogos.css';

const PartnerLogos: React.FC = () => {
  return (
    <section className="partner-logos-section">
      <div className="partner-logo-card">
        <img 
          src="https://api.builder.io/api/v1/image/assets/TEMP/548487c4b41fbe61af6e61e31aff9a2149089bfb?width=608" 
          alt="Sierra Pacific Mortgage Logo" 
          className="partner-logo"
        />
      </div>
      <div className="partner-logo-card">
        <img 
          src="https://api.builder.io/api/v1/image/assets/TEMP/6e0dd72837563fabb3a036993de374e709a69fb2?width=527" 
          alt="AmiVest Logo" 
          className="partner-logo"
        />
      </div>
      <div className="partner-logo-card">
        <img 
          src="https://api.builder.io/api/v1/image/assets/TEMP/1b42400f0879d4e23c30a78eea62d6e536563b76?width=567" 
          alt="Advancial Logo" 
          className="partner-logo"
        />
      </div>
    </section>
  );
};

export default PartnerLogos;
